import { cdnClient, client, ContentTypes, ResponseData } from '../galaxyClient';

export type Impacter = ResponseData<ContentTypes, '/v2/impacters/{impacterId}', 'get'>;

export const getCurrentImpacterProfile = async () => {
  const { data } = await client().content.GET('/v2/impacters/me', {});
  return data;
};

export const getImpacterById = async (
  impacterId: number | string,
  { skipContentfulData }: { skipContentfulData?: boolean } = {},
) => {
  let impacter: Impacter;
  if (Number.isInteger(Number(impacterId))) {
    const { data } = await client().content.GET('/v2/impacters/{impacterId}', {
      params: {
        path: { impacterId: Number(impacterId) },
        query: { skipContentfulData },
      },
    });
    impacter = data;
  } else {
    const {
      data: { result },
    } = await client().content.GET('/v2/impacters/', {
      params: {
        query: {
          externalId: [impacterId as string],
          skipContentfulData,
        },
      },
    });
    impacter = result[0];
  }
  return impacter;
};

export type GetImpacters = {
  initiativeIds?: string[];
  impacterIds?: string[];
  impactPartnerIds?: string[];
  impacterUrlNames?: string[];
  anyTagNames?: string[];
  q?: string;
  skipContentfulData?: boolean;
};
export const getImpacters = async ({
  initiativeIds,
  impacterIds,
  impactPartnerIds,
  impacterUrlNames,
  anyTagNames,
  q,
  skipContentfulData,
}: GetImpacters = {}) => {
  const { data } = await cdnClient().content.GET('/v2/impacters/', {
    params: {
      query: {
        initiativeId: initiativeIds,
        externalId: impacterIds,
        impactPartnerId: impactPartnerIds,
        impacterUrlName: impacterUrlNames,
        anyTagName: anyTagNames,
        q,
        skipContentfulData,
      },
    },
  });

  return data;
};
